module.exports = __webpack_public_path__ + "static/media/Guardar.a78832bc.svg";